import { Component } from "react";
import "./ListWithPagination.css";
import ReactPaginate from "react-paginate";

export const ITEMS_PER_PAGE = 10;
const PAGE_RANGE_DISPLAYED = 5;

export default class ListWithPagination extends Component {
  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePageSchemaChange = this.handlePageSchemaChange.bind(this);
  }
  handlePageSchemaChange(data) {
    this.props.refresh &&
      this.props.refresh(
        {
          page: data.selected + 1,
          size: ITEMS_PER_PAGE,
        },
        data.selected + 1
      );
  }

  handlePageChange(data) {
    const from = data.selected * ITEMS_PER_PAGE;
    const to = from + ITEMS_PER_PAGE;
    this.props.refresh &&
      this.props.refresh(
        {
          from: from,
          to: to,
        },
        data.selected + 1
      );
  }

  render() {
    return (
      <div className={this.props.className || ""}>
        {this.props.children}

        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          pageCount={Math.ceil(this.props.total / ITEMS_PER_PAGE)}
          forcePage={this.props.activePage - 1}
          marginPagesDisplayed={1}
          pageRangeDisplayed={PAGE_RANGE_DISPLAYED}
          onPageChange={
            this.props.schema === "page"
              ? this.handlePageSchemaChange
              : this.handlePageChange
          }
          containerClassName={this.props.total === 0 ? "hidden" : "pagination"}
          activeClassName={"active"}
        />
      </div>
    );
  }
}

export class ListWithPaginationForPageSchema extends Component {
  /**
   * This is a new ListWithPagination that supports new server's PageSchema
   * with `page` and `size` parameters instead of `from` and `to`.
   */
  constructor(props) {
    super(props);

    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange(data) {
    this.props.refresh &&
      this.props.refresh(
        {
          page: data.selected + 1,
          size: ITEMS_PER_PAGE,
        },
        data.selected + 1
      );
  }

  render() {
    return (
      <div>
        {this.props.children}

        <ReactPaginate
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          pageCount={Math.ceil(this.props.total / ITEMS_PER_PAGE)}
          forcePage={this.props.activePage - 1}
          marginPagesDisplayed={1}
          pageRangeDisplayed={PAGE_RANGE_DISPLAYED}
          onPageChange={this.handlePageChange}
          containerClassName={
            this.props.total <= ITEMS_PER_PAGE ? "hidden" : "pagination"
          }
          activeClassName={"active"}
        />
      </div>
    );
  }
}
